/* DAVINCI 2026: quantity tiers, add-ons, quick add, reveal. No dependencies. */
(() => {
  if (window.__dv) return; window.__dv = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const eur = c => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  /* ---------- quantity tiers ---------- */
  function qtyFor(el) {
    const scope = el.closest('form, product-form, .product-information, .product, section') || document;
    const inp = $('input[name="quantity"]', scope) || $('form[action*="/cart/add"] input[name="quantity"]');
    const q = parseInt(inp && inp.value, 10); return q > 0 ? q : 1;
  }
  function paintTiers(el) {
    const q = qtyFor(el); let active = null;
    $$('[data-dv-tier]', el).forEach(r => { if (q >= +r.dataset.dvTier) active = r; r.classList.remove('is-active'); });
    if (active) active.classList.add('is-active');
    const hint = $('[data-dv-tier-hint]', el);
    if (hint) {
      const next = $$('[data-dv-tier]', el).find(r => +r.dataset.dvTier > q);
      hint.textContent = next ? (el.dataset.tHint || 'Noch {n} Stück bis zur nächsten Staffel.').replace('{n}', +next.dataset.dvTier - q) : (el.dataset.tTop || 'Höchste Staffel erreicht.');
    }
  }
  const tiers = () => $$('[data-dv-tiers]').forEach(paintTiers);
  ['input', 'change'].forEach(ev => document.addEventListener(ev, e => { if (e.target.name === 'quantity') tiers(); }));
  document.addEventListener('click', e => { if (e.target.closest('quantity-selector, .quantity, [name="plus"], [name="minus"]')) setTimeout(tiers, 60); });

  /* ---------- toast + cart refresh ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'dv-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }
  function refreshCart(open) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (open) {
      const t = document.getElementById('cart-drawer-toggle');
      const d = document.getElementById('Cart-Drawer');
      if (d && typeof d.open === 'function') d.open(); else if (t) t.click();
    }
  }
  async function addItems(items) {
    const r = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || r.status); return j;
  }
  window.DV = Object.assign(window.DV || {}, { toast, refreshCart, addItems });

  /* quick add buttons: <button data-dv-add data-variant="123" data-name="..."> */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-dv-add]'); if (!b) return;
    e.preventDefault(); if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    try { await addItems([{ id: +b.dataset.variant, quantity: +(b.dataset.qty || 1) }]); toast(`${b.dataset.name || 'Artikel'} liegt im Warenkorb.`); refreshCart(b.hasAttribute('data-dv-open')); }
    catch (err) { toast(`Nicht hinzugefügt: ${err.message}`); }
    finally { b.removeAttribute('aria-busy'); }
  });

  /* ---------- add-ons ("Passt dazu") ---------- */
  function checkedAddons(box) {
    return $$('input[type=checkbox][data-dv-addon]:checked', box).map(cb => {
      const sel = cb.closest('.dv-addon').querySelector('select');
      return { id: +(sel ? sel.value : cb.value), quantity: 1 };
    });
  }
  function paintAddonSum(box) {
    const n = $$('input[data-dv-addon]:checked', box);
    const sum = n.reduce((a, cb) => a + (+cb.dataset.price || 0), 0);
    const out = $('[data-dv-addon-sum]', box);
    if (out) out.textContent = n.length ? (box.dataset.tSum || '{n} Zusatzartikel (+{sum}) werden mit in den Warenkorb gelegt.').replace('{n}', n.length).replace('{sum}', eur(sum)) : '';
  }
  document.addEventListener('change', e => { const box = e.target.closest('[data-dv-addons]'); if (box) { if (e.target.tagName === 'SELECT') { const o = e.target.selectedOptions[0]; const cb = e.target.closest('.dv-addon').querySelector('input[data-dv-addon]'); if (o && cb) cb.dataset.price = o.dataset.price; } paintAddonSum(box); } });
  let pending = null;
  function flushAddons(box) {
    const items = checkedAddons(box); if (!items.length || pending) return;
    pending = addItems(items).then(() => { $$('input[data-dv-addon]:checked', box).forEach(cb => { cb.checked = false; }); paintAddonSum(box); refreshCart(false); })
      .catch(err => toast(`Zusatzartikel nicht hinzugefügt: ${err.message}`))
      .finally(() => { pending = null; });
  }
  // Vision fires cart:item-added after its own add-to-cart (cart drawer enabled)
  document.addEventListener('cart:item-added', () => { const box = $('[data-dv-addons]'); if (box) setTimeout(() => flushAddons(box), 150); });

  /* ---------- reveal ---------- */
  function reveal() {
    const els = $$('[data-dv-reveal]:not(.is-in)'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
  }

  function init() { tiers(); reveal(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('quick-view:open', () => setTimeout(init, 400));
  document.addEventListener('cart-drawer:open', init);
  document.addEventListener('line-item:change:end', init);
})();
/* DAVINCI 2026: product-card strength pills (snippets/dv-quick-add.liquid) */
(() => {
  document.addEventListener('click', e => {
    const pill = e.target.closest('.dv-qa__pill');
    if (!pill || pill.disabled) return;
    e.preventDefault();
    const box = pill.closest('[data-dv-qa]');
    box.querySelectorAll('.dv-qa__pill').forEach(b => b.setAttribute('aria-checked', b === pill ? 'true' : 'false'));
    const add = box.querySelector('.dv-qa__add');
    add.dataset.productId = pill.dataset.vid; add.disabled = false;
  });
  document.addEventListener('keydown', e => {
    const pill = e.target.closest && e.target.closest('.dv-qa__pill');
    if (!pill || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    const pills = [...pill.parentElement.querySelectorAll('.dv-qa__pill:not([disabled])')];
    const n = pills[(pills.indexOf(pill) + (e.key === 'ArrowRight' ? 1 : -1) + pills.length) % pills.length];
    n.focus(); n.click(); e.preventDefault();
  });
})();

/* DAVINCI 2026: cart goal bar animation (drawer + cart page) */
(function(){
  var KEY='dvGoalFill', reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(el){
    if(el.__dvg) return; el.__dvg=1;
    var fill=el.querySelector('.dv-goal__fill'); if(!fill) return;
    var to=parseFloat(el.getAttribute('data-fill'))||0, from;
    try{from=parseFloat(sessionStorage.getItem(KEY));}catch(e){}
    if(isNaN(from)) from=0;
    var prevShip=from>=35, prevDisc=from>=100;
    try{sessionStorage.setItem(KEY,String(to));}catch(e){}
    if(reduce||from===to){fill.style.width=to+'%';return;}
    fill.style.transition='none'; fill.style.width=from+'%'; void fill.offsetWidth;
    requestAnimationFrame(function(){ fill.style.transition=''; fill.style.width=to+'%'; });
    var ms=el.querySelector('.dv-goal__mk--ship.is-on'), md=el.querySelector('.dv-goal__mk--disc.is-on');
    setTimeout(function(){
      if(ms&&!prevShip) ms.classList.add('dv-pop');
      if(md&&!prevDisc) md.classList.add('dv-pop');
    },700);
  }
  function scan(root){ (root||document).querySelectorAll('[data-dv-goal]').forEach(run); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',function(){scan();});
  new MutationObserver(function(ms){
    for(var i=0;i<ms.length;i++){ if(ms[i].addedNodes.length){ scan(); return; } }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* DAVINCI 2026: cart liquid quick-select sheet (tap strength = add instantly) */
(function(){
  var sheet, lastBtn;
  function close(){ if(!sheet) return; sheet.classList.remove('is-on'); sheet.setAttribute('aria-hidden','true'); document.removeEventListener('keydown',onKey,true); if(lastBtn&&document.contains(lastBtn)) lastBtn.focus(); }
  function onKey(e){ if(e.key==='Escape'){ e.stopPropagation(); e.preventDefault(); close(); } }
  function build(){
    sheet=document.createElement('div'); sheet.className='dv-qs'; sheet.setAttribute('aria-hidden','true');
    sheet.innerHTML='<div class="dv-qs__bg" data-qs-close></div><div class="dv-qs__box" role="dialog" aria-modal="true" aria-labelledby="dvQsT"><button type="button" class="dv-qs__x" data-qs-close aria-label="Schließen"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><p class="dv-qs__b"></p><p class="dv-qs__t" id="dvQsT"></p><p class="dv-qs__l">Nikotinstärke wählen – wird sofort hinzugefügt</p><div class="dv-qs__pills" role="group"></div><p class="dv-qs__msg" role="status"></p></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click',async function(e){
      if(e.target.closest('[data-qs-close]')){ close(); return; }
      var b=e.target.closest('.dv-qs__pill'); if(!b||b.disabled||sheet.getAttribute('aria-busy')==='true') return;
      sheet.setAttribute('aria-busy','true'); b.classList.add('is-busy');
      try{
        await window.DV.addItems([{id:+b.dataset.vid,quantity:1}]);
        window.DV.toast(sheet.dataset.label+' ('+b.dataset.mg+' mg) liegt im Warenkorb.');
        close(); window.DV.refreshCart(false);
      }catch(err){ sheet.querySelector('.dv-qs__msg').textContent='Nicht hinzugefügt: '+err.message; }
      finally{ sheet.removeAttribute('aria-busy'); b.classList.remove('is-busy'); }
    });
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-dv-lq-open]'); if(!btn) return;
    e.preventDefault(); if(!window.DV||!window.DV.addItems) return;
    if(!sheet) build(); lastBtn=btn;
    var opts=[]; try{opts=JSON.parse(btn.dataset.opts);}catch(_){}
    var by={}; opts.forEach(function(o){ var k=String(o[0]); if(!by[k]||(!by[k][2]&&o[2])) by[k]=o; });
    opts=Object.keys(by).map(function(k){return by[k];}).sort(function(a,b){return parseFloat(a[0])-parseFloat(b[0]);});
    var pref=btn.dataset.pref||'', cur=btn.dataset.cur||'';
    var hl=opts.some(function(o){return o[0]===pref&&o[2];})?pref:cur;
    sheet.querySelector('.dv-qs__b').textContent=btn.dataset.brand+' · '+(btn.dataset.price||'').replace(/&nbsp;/g,' ');
    sheet.querySelector('.dv-qs__t').textContent=btn.dataset.name;
    sheet.querySelector('.dv-qs__msg').textContent='';
    sheet.dataset.label=btn.dataset.brand+' '+btn.dataset.name.replace(/\b\w/g,function(c){return c.toUpperCase();});
    var wrap=sheet.querySelector('.dv-qs__pills'); wrap.innerHTML='';
    opts.forEach(function(o){
      var b=document.createElement('button'); b.type='button'; b.className='dv-qs__pill'+(o[0]===hl?' is-hl':'');
      b.dataset.vid=o[1]; b.dataset.mg=o[0]; b.disabled=!o[2];
      b.innerHTML='<span>'+o[0]+'</span><small>mg/ml</small>'+(o[0]===pref&&o[2]?'<em>wie im Warenkorb</em>':'')+(!o[2]?'<em>ausverkauft</em>':'');
      b.setAttribute('aria-label',o[0]+' mg/ml'+(o[2]?' hinzufügen':' ausverkauft'));
      wrap.appendChild(b);
    });
    sheet.classList.add('is-on'); sheet.setAttribute('aria-hidden','false');
    document.addEventListener('keydown',onKey,true);
    var f=wrap.querySelector('.is-hl:not(:disabled)')||wrap.querySelector('button:not(:disabled)'); if(f) setTimeout(function(){f.focus({preventScroll:true});},50);
  });
})();

/* DAVINCI 2026: bundle price comparison follows the selected variant */
(function(){
  function fmt(c){return (c/100).toFixed(2).replace('.',',')+'\u00a0€';}
  function upd(){
    document.querySelectorAll('[data-dv-bundle]').forEach(function(el){
      var map; try{map=JSON.parse(el.querySelector('[data-dv-bundle-map]').textContent);}catch(e){return;}
      var form=el.closest('.product-information, .product-detail, main')||document;
      var inp=form.querySelector('form[action*="/cart/add"] [name="id"]');
      var id=(inp&&inp.value)||new URLSearchParams(location.search).get('variant'); var d=map[id]; if(!d||!d[0]) return;
      el.querySelector('[data-bp-sum]').textContent=fmt(d[0]);
      el.querySelector('[data-bp-price]').textContent=fmt(d[1]);
      el.querySelector('[data-bp-save]').textContent=fmt(d[0]-d[1]);
      var n=el.querySelector('[data-bp-n]'); if(n&&d[2]) n.textContent=d[2];
    });
  }
  document.addEventListener('change',function(e){ if(document.querySelector('[data-dv-bundle]')) setTimeout(upd,80); });
  document.addEventListener('click',function(e){ if(document.querySelector('[data-dv-bundle]')&&e.target.closest('variant-selects, variant-radios, .variant-picker, [class*="variant"]')) setTimeout(upd,120); });
})();

/* DAVINCI 2026: interactive bundle card (tile / hero) */
(function(){
  function fmt(c){return (c/100).toFixed(2).replace('.',',')+'\u00a0€';}
  function state(card){
    var o1=card.querySelector('.dv-bc__c.is-on'), o2=card.querySelector('.dv-bc__s.is-on');
    var map=card.__map||(card.__map=JSON.parse(card.querySelector('[data-dv-bc-map]').textContent));
    var v=map[o1.dataset.bcO1+'|'+o2.dataset.bcO2]; if(!v) return;
    var img=card.querySelector('.dv-bc__im');
    if(img&&v.img){ img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src=v.img; }
    card.querySelector('[data-bc-n]').textContent=v.n;
    card.querySelector('[data-bc-colour]').textContent=o1.dataset.bcO1;
    card.querySelector('[data-bc-sum]').textContent=fmt(v.s);
    card.querySelector('[data-bc-price]').textContent=fmt(v.p);
    card.querySelector('[data-bc-save]').textContent=fmt(v.s-v.p);
    card.querySelectorAll('[data-bc-link]').forEach(function(a){ a.href=a.href.split('?')[0]+'?variant='+v.id; });
  }
  document.addEventListener('click',async function(e){
    var card=e.target.closest&&e.target.closest('[data-dv-bc]'); if(!card) return;
    var b=e.target.closest('.dv-bc__c, .dv-bc__s');
    if(b){ var cls=b.classList.contains('dv-bc__c')?'.dv-bc__c':'.dv-bc__s';
      card.querySelectorAll(cls).forEach(function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-pressed',on?'true':'false');});
      state(card); return; }
    var add=e.target.closest('[data-bc-add]');
    if(add&&!add.disabled&&window.DV){ e.preventDefault(); add.setAttribute('aria-busy','true');
      try{ await window.DV.addItems([{id:+add.dataset.variant,quantity:1}]); window.DV.refreshCart(true); }
      catch(err){ window.DV.toast('Nicht hinzugefügt: '+err.message); }
      finally{ add.removeAttribute('aria-busy'); } }
  });
})();
